export const SPINNER_SIZE = {
  s: "size-s",
  m: "size-m",
  l: "size-l",
  xl: "size-xl",
  "2xl": "size-2xl",
  "3xl": "size-3xl",
  "4xl": "size-4xl",
  "5xl": "size-5xl",
} as const

export type SpinnerSize = keyof typeof SPINNER_SIZE
